<template>
  <div >
    <v-card flat shaped>
      <v-container class="pt-2" fluid >
        <v-parallax
            dark
            height="250vmin"
            :src="require('../assets/TopBanner.jpg')"
        >
          <v-row no-gutters justify="center">
              <v-col class="text-right pt-10" xs="6" sm="6">
                <p class="my-4 display-1 salmonOrange--text">{{globalLanguage.landingWelcome}}</p>
                <p class="my-4 headline  salmonOrange--text font-italic">{{globalLanguage.landingWelcome2}} </p>
                
                <v-btn :color="'#3b5998'" dark large @click="openLink('https://www.facebook.com/izitechsolution')">
                  <v-icon large>mdi-facebook</v-icon>
                </v-btn>
                <v-btn :color="'#d6249f'" dark large @click="openLink('https://www.instagram.com/izitech_solution/')">
                  <v-icon large>mdi-instagram</v-icon>
                </v-btn>
                <div class="pa-4 d-flex flex-column justify-space-between align-end">
                  <v-img
                      width="50"
                      :src="require('../assets/business logo.png')"
                  ></v-img>
                </div>

              </v-col>
              <!-- <v-row no-gutters>
                <v-col class="text-center"  xs="4" sm="12">
                  
                </v-col>
              </v-row>  -->
              <v-col class="text-left " xs="6" sm="6">
                  <v-img
                      max-height="345"
                      max-width="369"
                      :src="require('../assets/izzul.png')"
                  ></v-img>
                  
              </v-col>
            </v-row>
          </v-parallax>
        </v-container>
    </v-card>

    <v-card :color="'white'" min-height="200" class="pa-1" flat shaped>
        <v-container class="pt-3" >
            <p :class="'font-weight-bold text-center headline pa-1 customGrey--text'">{{globalLanguage.landingIntro}}</p>
            <v-row no-gutters>
                <v-col class="text-center"  xs="12" sm="12">
                    <p :class="'font-weight-light text-center title pa-1 customGrey--text'">{{globalLanguage.landingIntro1}}</p>
                </v-col>
            </v-row> 

            <p :class="'font-weight-bold text-center headline pa-1 customGrey--text'">{{globalLanguage.landingIntro2}}</p>
            <v-row no-gutters>
                <v-col class="text-center"  xs="12" sm="12">
                    <p :class="'font-weight-light text-center title pa-1 customGrey--text'">{{globalLanguage.landingIntro3}}</p>
                    <v-btn outlined :color="globalColorC" x-large width="250" @click="routePage('Portfolio')">
                      <v-icon>mdi-briefcase-outline</v-icon>
                      <span :class="'font-weight-medium text-center title pa-1 customGrey--text'">Portfolio</span>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card>

    <v-card :color="globalColorC" min-height="200" class="pa-1" flat shaped>
        <v-container class="pt-3" >
            <p :class="'font-weight-bold text-center headline pa-1 salmonOrange--text'">{{globalLanguage.landingSolution}}</p>
            <v-row no-gutters>
                <v-col class="text-center"  xs="4" sm="4" @click="mobileTips = !mobileTips">
                  <v-icon color="salmonOrange" x-large>mdi-cellphone</v-icon>
                  <p :class="'text-center title pa-1 salmonOrange--text'">
                    {{globalLanguage.landingSolutionMobile}}
                    <!-- <v-tooltip bottom v-model="mobileTips">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon  v-bind="attrs" v-on="on" color="salmonOrange" small>mdi-help-circle-outline</v-icon>
                      </template>
                      <span>{{globalLanguage.landingSolutionMobileTips}}</span>
                    </v-tooltip> -->
                  </p>
                  <v-btn outlined :color="globalColorB" @click="openPackageDialog('Mobile')">
                    <v-icon :color="globalColorB" small>mdi-package-variant</v-icon>
                    <span :class="'font-weight-medium text-center subtitle-1 pa-1 salmonOrange--text'">{{globalLanguage.landingSolutionPackage}}</span>
                  </v-btn>
                </v-col>
                <v-col class="text-center"  xs="4" sm="4" @click="webTips = !webTips">
                  <v-icon color="salmonOrange" x-large>mdi-web</v-icon>
                  <p :class="'text-center title pa-1 salmonOrange--text'">
                    {{globalLanguage.landingSolutionWeb}}
                    <!-- <v-tooltip bottom v-model="webTips">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon  v-bind="attrs" v-on="on" color="salmonOrange" small>mdi-help-circle-outline</v-icon>
                      </template>
                      <span>{{globalLanguage.landingSolutionWebTips}}</span>
                    </v-tooltip> -->
                  </p>
                  <v-btn outlined :color="globalColorB"  @click="openPackageDialog('Web')">
                    <v-icon :color="globalColorB" small>mdi-package-variant</v-icon>
                    <span :class="'font-weight-medium text-center subtitle-1 pa-1 salmonOrange--text'">{{globalLanguage.landingSolutionPackage}}</span>
                  </v-btn>
                </v-col>
                <v-col class="text-center"  xs="4" sm="4" @click="gameTips = !gameTips">
                  <v-icon color="salmonOrange" x-large>mdi-gamepad-variant-outline</v-icon>
                  <p :class="'text-center title pa-1 salmonOrange--text'">
                    {{globalLanguage.landingSolutionGame}}
                    <!-- <v-tooltip bottom v-model="gameTips">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon  v-bind="attrs" v-on="on" color="salmonOrange" small>mdi-help-circle-outline</v-icon>
                      </template>
                      <span>{{globalLanguage.landingSolutionGameTips}}</span>
                    </v-tooltip> -->
                  </p>
                  <v-btn outlined :color="globalColorB"  @click="openPackageDialog('Video Game')">
                    <v-icon :color="globalColorB" small>mdi-package-variant</v-icon>
                    <span :class="'font-weight-medium text-center subtitle-1 pa-1 salmonOrange--text'">{{globalLanguage.landingSolutionPackage}}</span>
                  </v-btn>
                </v-col>
            </v-row>

            <v-row no-gutters class="pt-2">
                <v-col class="text-center"  xs="4" sm="4">
                </v-col>
                <v-col class="text-center"  xs="4" sm="4">
                    <p :class="'font-weight-medium text-center headline pa-1 salmonOrange--text'">{{globalLanguage.landingSolutionOr}}</p>
                </v-col>
                <v-col class="text-center"  xs="4" sm="4">
                </v-col>
            </v-row>

            <v-row no-gutters>
                <v-col class="text-center"  xs="12" sm="12">
                    <p :class="'font-weight-bold text-center headline pa-1 salmonOrange--text'">{{globalLanguage.landingSolutionIdea}}</p>
                </v-col>
            </v-row>
        </v-container>
    </v-card>

    <v-card :color="'white'" min-height="200" class="pa-3" flat shaped>
        <v-container class="pt-3" >
            <p :class="'font-weight-bold text-center headline pa-2 customGrey--text'">{{globalLanguage.landingHire}}</p>
            <v-row no-gutters>
                <v-col class="text-center"  xs="12" sm="12">
                    <p :class="'font-weight-light text-center title pa-2 customGrey--text'">{{globalLanguage.landingHire1}}</p>
                </v-col>
            </v-row> 

            <v-row no-gutters>
                <v-col class="text-center"  xs="4" sm="2">
                </v-col>
                <v-col class="text-center"  xs="4" sm="8">
                    <v-btn :color="globalColorC" x-large width="250" @click="openHireMeDialog()">
                      <v-icon :color="globalColorB" >mdi-handshake</v-icon>
                      <span :class="'font-weight-bold text-center title pa-2 salmonOrange--text'">HIRE ME</span>
                    </v-btn>
                </v-col>
                <v-col class="text-center"  xs="4" sm="2">
                </v-col>
            </v-row> 

            <v-row no-gutters>
                <v-col class="text-center"  xs="4" sm="4">
                </v-col>
                <v-col class="text-center"  xs="4" sm="4">
                    <p :class="'font-weight-medium text-center headline pt-5 customGrey--text'">{{globalLanguage.landingSolutionOr}}</p>
                </v-col>
                <v-col class="text-center"  xs="4" sm="4">
                </v-col>
            </v-row>

            <v-row no-gutters>
                <v-col class="text-center"  xs="8" sm="12">
                    <p :class="'font-weight-light text-center title pt-2 customGrey--text'">{{globalLanguage.landingHire2}}</p>
                </v-col>
            </v-row>

            <v-row no-gutters>
                <v-col class="text-center pa-1"  xs="8" sm="12">
                  <v-icon color="#25D366" class="pb-2">mdi-whatsapp</v-icon>
                  <span :class="'font-weight-medium text-center headline pa-1 salmonOrange--text'">011-69253770</span>
                </v-col>
            </v-row>
        </v-container>
    </v-card>

    <v-card :color="globalColorC" min-height="200" class="pa-3" flat shaped>
        <v-container class="pt-3" >
            <p :class="'font-weight-medium text-center headline pa-1 salmonOrange--text'">{{globalLanguage.landingPrice1}}</p>
            <v-row no-gutters>
                <v-col class="text-center"  xs="4" sm="12">
                    <p :class="'font-weight-light text-center title pa-2 salmonOrange--text'">{{globalLanguage.landingPrice2}}</p>
                    <v-btn outlined :color="globalColorB" x-large width="250" @click="budgetDialog = !budgetDialog">
                      <v-icon :color="globalColorB" >mdi-currency-usd</v-icon>
                      <span :class="'font-weight-medium text-center title pa-2 salmonOrange--text'">Budget</span>
                    </v-btn>
                </v-col>
            </v-row>

        </v-container>
    </v-card>

    <v-card :color="'white'" min-height="200" class="pa-3" flat shaped>
        <v-container class="pt-3" >

            <v-row no-gutters>
                <v-col class="text-center"  xs="4" sm="12">
                  <Feedback
                    :globalColorA="globalColorA"
                    :globalColorB="globalColorB"
                    :globalColorC="globalColorC"
                    :globalLanguage="globalLanguage"
                  ></Feedback>
                </v-col>
            </v-row> 

        </v-container>
    </v-card>

    <v-dialog
        class="z-index:100"
        v-model="packageDialog"
        persistent
        transition="dialog-bottom-transition"
        width="1400"
      >
      <v-card >
        <v-toolbar
          dark
          :color="globalColorC"
        >
          <v-btn
            icon
            dark
            @click="packageDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title :class="'font-weight-medium title pa-3 salmonOrange--text'">{{globalLanguage.landingSolutionPackage}}</v-toolbar-title>

        </v-toolbar>
        <v-list
          three-line
          subheader
        >
        <v-container class="pt-3" >
          <v-row no-gutters>
            <v-col class="text-center pa-2"  xs="12" lg="4" v-for="(item,index) in packageSelected" :key="index">
              <v-card>
                <v-card color="customGrey">
                  <p :class="'font-weight-medium title pa-3 salmonOrange--text'">{{item.type}}</p>
                </v-card>

                <p :class="'font-weight-light subtitle-1 pa-1 customGrey--text'">Content</p>                
                
                <v-divider></v-divider>

                <p :class="'font-weight-light subtitle-2 pt-4 customGrey--text'">Starting From </p>
                <p :class="'font-weight-bold title pb-2 customGrey--text'">RM {{item.price}}</p>
              </v-card>
            </v-col>
          </v-row>

        </v-container>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog
        class="z-index:100"
        v-model="clientDialog"
        persistent
        transition="dialog-bottom-transition"
        width="800"
      >
      <v-card >
        <v-toolbar
          dark
          :color="globalColorC"
        >
          <v-btn
            icon
            dark
            @click="clientDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title :class="'font-weight-medium title pa-3 salmonOrange--text'">Hire Me</v-toolbar-title>
          <!-- <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialog = false"
            >
              Save
            </v-btn>
          </v-toolbar-items> -->
        </v-toolbar>
        <v-list
          three-line
          subheader
        >
          <v-subheader>{{globalLanguage.hireContactInfo}}</v-subheader>
          <v-form v-model="clientValidate">
            <v-list-item>
              <v-list-item-content class="pa-2">
                <v-list-item-title>{{globalLanguage.hireName}} : </v-list-item-title>
                <v-text-field
                  :full-width="true"
                  clearable
                  :placeholder="globalLanguage.hireName"
                  outlined
                  :value="clientName"
                  v-model="clientName"
                  :rules="clientGeneralRule"
                  dense
                  :color="globalColorB"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content class="pa-2">
                <v-list-item-title>{{globalLanguage.hireEmail}} : </v-list-item-title>
                <v-text-field
                  type="email"
                  :full-width="true"
                  clearable
                  :placeholder="globalLanguage.hireEmail"
                  outlined
                  :value="clientEmail"
                  v-model="clientEmail"
                  :rules="clientEmailRules"
                  dense
                  :color="globalColorB"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content class="pa-2">
                <v-list-item-title>{{globalLanguage.hireMobile}} : </v-list-item-title>
                <v-text-field
                  :full-width="true"
                  clearable
                  :placeholder="globalLanguage.hireMobile"
                  outlined
                  :value="clientNumber"
                  v-model="clientNumber"
                  :rules="clientNumberRules"
                  dense
                  :color="globalColorB"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-content class="pa-2">
                <v-list-item-title>{{globalLanguage.hireBudget}} : </v-list-item-title>
                <v-text-field
                  type="number"
                  :full-width="true"
                  clearable
                  :placeholder="globalLanguage.hireBudget"
                  outlined
                  :value="clientBudget"
                  v-model="clientBudget"
                  :rules="clientGeneralRule"
                  dense
                  :color="globalColorB"
                  step="100"
                ></v-text-field>

                <v-slider
                  v-model="clientBudget"
                  class="align-center"
                  :max="maxBudget"
                  :min="minBudget"
                  step="100"
                  hide-details
                  :color="globalColorB"
                  :track-color="globalColorC"
                  :thumb-size="40"
                  thumb-label
                >
                </v-slider>

                <v-checkbox
                  v-if="clientBudget >= 20000"
                  class="right"
                  v-model="clientBudgetMore"
                  :label="globalLanguage.hireBudgetMore"
                  :value="clientBudgetMore"
                  :color="globalColorB"
                ></v-checkbox>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content class="pa-2">
                <v-list-item-title>{{globalLanguage.hireService}} : </v-list-item-title>
                <v-select
                  :items="globalLanguage.hireServiceList"
                  :placeholder="globalLanguage.hireService"
                  outlined
                  :value="clientService"
                  v-model="clientService"
                  :rules="clientGeneralRule"
                  dense
                  :color="globalColorB"
                ></v-select>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content class="pa-2">
                <v-list-item-title>{{globalLanguage.hireMessage}} : </v-list-item-title>
                <v-textarea
                  outlined
                  clearable
                  :placeholder="globalLanguage.hireMessage"
                  :value="clientMessage"
                  v-model="clientMessage"
                  :rules="clientGeneralRule"
                  :color="globalColorB"
                ></v-textarea>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content class="pl-2">
                <v-checkbox
                  v-model="clientAgree"
                  :label="globalLanguage.hireAgree"
                  :value="clientAgree"
                  :color="globalColorB"
                ></v-checkbox>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content class="pa-2">
                <v-btn :color="globalColorC" x-large width="250" @click="sendViaWhatsapp()">
                  <v-icon color="#25D366" >mdi-whatsapp</v-icon>
                  <span :class="'font-weight-bold text-center title pa-1 salmonOrange--text'">{{globalLanguage.hireSendWs}}</span>
                </v-btn>
                <!-- <v-list-item-title>{{globalLanguage.hireMessage}} : </v-list-item-title> -->
              </v-list-item-content>
            </v-list-item>
          </v-form>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="clientError"
      width="500"
    >
      <v-card>
        <v-card-title class="headline customGrey salmonOrange--text lighten-2">
          {{globalLanguage.hireErrorMessage}}
        </v-card-title>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="globalColorB"
            text
            @click="clientError = false"
          >
            {{globalLanguage.hireErrorButton}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="budgetDialog"
      fullscreen
    >
     <v-toolbar
          dark
          :color="globalColorC"
        >
          <v-btn
            icon
            dark
            @click="budgetDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title :class="'font-weight-medium title pa-3 salmonOrange--text'">{{budgetItem.title}}</v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-card-text :class="'pa-3 font-weight-light text-left title customGrey--text'">
          {{budgetItem.explanationDeclare}}
        </v-card-text>

        <v-divider></v-divider>
        
        <v-expansion-panels class="pa-2">
          <v-expansion-panel
              v-for="(item,i) in budgetItem.dataSelection"
              :key="i"
              >
              
              <v-expansion-panel-header >
                <span :class="'font-weight-medium text-left title customGrey--text'">{{item.type}}</span>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                  <p :class="'font-weight-light text-left subtitle-1 pl-2 customGrey--text'">
                    {{item.explanation}}
                  </p>                  
                  <p :class="'font-weight-light text-left subtitle-1 pl-2 customGrey--text'">
                    {{item.explanation2}}
                  </p>
                  <p :class="'font-weight-light text-left subtitle-2 pl-2 customGrey--text'">
                    {{budgetItem.explanationStar}}
                  </p>
                  <v-simple-table :dense="true">
                      <template v-slot:default >
                          <thead>
                              <tr>
                                  <th></th>
                                  <th class="text-left">
                                    {{budgetItem.list}}
                                  </th>
                                  <th class="text-left">
                                    {{budgetItem.price}}
                                  </th>
                                  <th class="text-left">
                                    {{budgetItem.renew}}
                                  </th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr
                                  v-for="(packageItem,j) in item.package"
                                  :key="j"
                              >
                                <td>
                                  <v-checkbox
                                    :color="globalColorB"
                                    v-model="packageItem.selected"
                                  ></v-checkbox>
                                </td>
                                <td>{{ packageItem.name }}</td>
                                <td>{{ packageItem.price }}</td>
                                <td>{{ packageItem.renew }}</td>
                              </tr>
                          </tbody>
                      </template>
                  </v-simple-table>
                  <p :class="'font-weight-light text-left subtitle-1 pl-2 customGrey--text'">
                    {{budgetItem.budgetCalculate}} {{budgetCalculation(item.package)}}
                  </p>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-dialog>
    
  </div>
  
</template>

<script>
import PRICINGBM from "../languageJSON/pricingBm.json"
import PRICINGENG from "../languageJSON/pricingEng.json"

import Feedback from "../components/subComponent/feedback"
export default {
  components:{
    Feedback : Feedback
  },
  name: 'Landing',
  props: ['globalColorA','globalColorB',"globalColorC","globalLanguage"],
  data () {
    return {

      mobileTips : false,
      webTips : false,
      gameTips : false,

      packageDialog : false,
      packageSelected : {},

      clientDialog: false,

      minBudget: 0,
      maxBudget: 20000,

      clientValidate: true,
      clientGeneralRule: [
        v => !!v || '',
      ],
      clientName: "",
      clientEmail: "",
      clientEmailRules: [
        v => !!v || '',
        v => /.+@.+\..+/.test(v) || '',
      ],
      clientNumber: "",
      clientNumberRules:[
        v => v > 0 || 'Enter Phone Number Correctly',
        v => /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(v) || '',
      ],
      clientBudget: 500,
      clientBudgetMore : false,
      clientService: "",
      clientMessage: "",
      clientAgree: false,

      clientError:false,

      budgetDialog:false,
      budgetItem: []

    }
  },

  watch: {
    clientBudgetMore: function () 
    {
      if(this.clientBudget <= 20000)
      {
        this.clientBudgetMore = false
      }
    },
    globalLanguage()
    {
        this.addPricing()
    },
  },

  mounted()
  {
    window.scrollTo(0, 0)
    this.addPricing()
  },

  methods:
  {
    openPackageDialog(packageName)
    {
      this.packageDialog = true

      if(packageName == "Mobile")
      {
        this.packageSelected = this.budgetItem.packageSelection.mobile
      }

      else if(packageName == "Web")
      {
        this.packageSelected = this.budgetItem.packageSelection.web
      }

      else if(packageName == "Video Game")
      {
        this.packageSelected = this.budgetItem.packageSelection.videoGame
      }
    },

    openHireMeDialog()
    {
        this.clientDialog = true
    },

    checkIfEmpty(checkedText)
    {
      if(checkedText == "" || checkedText == null)
      {
        return true
      }

      return false
    },

    checkedMessageLine(checkedText)
    {
      return checkedText.replaceAll("\n","%0D%0A")
    },

    sendViaWhatsapp()
    {

      if(this.clientValidate && this.clientAgree) // all form filled
      {
        if(this.globalLanguage.selectedLanguage == "eng")
        {
          var name = "*Name* %0D%0A " + (this.clientName != "" ? this.clientName : "No name provided")
          var email = "*Email* %0D%0A " + (this.clientEmail != "" ? this.clientEmail : "no email provided")
          var number = "*Contact Number* %0D%0A " + (this.clientNumber != "" ? this.clientNumber : "no number provided")
          var budget = "*Budget* %0D%0A RM " + (this.clientBudget != "" ? this.clientBudget : "No budget provided")
          var service = "*Service* %0D%0A " + (this.clientService != "" ? this.clientService : "no service provided")
          var message = "*Message / Project Detail* %0D%0A " + (this.clientMessage != "" ? this.checkedMessageLine(this.clientMessage) : "no message provided")
        }
        else
        {
          var name = "*Nama* %0D%0A " + (this.clientName != "" ? this.clientName : "tiada name diberikan")
          var email = "*Emel* %0D%0A " + (this.clientEmail != "" ? this.clientEmail : "tiade emel diberikan")
          var number = "*Nombor Telefon* %0D%0A " + (this.clientNumber != "" ? this.clientNumber : "tiada nombor telefon diberikan")
          var budget = "*Bajet* %0D%0A RM" + (this.clientBudget != "" ? this.clientBudget : "tiada bajet diberikan")
          var service = "*Service* %0D%0A " + (this.clientService != "" ? this.clientService : "tiada perkhidmatan diberikan")
          var message = "*Mesej / Maklumat Projek* %0D%0A " + (this.clientMessage != "" ? this.checkedMessageLine(this.clientMessage) : "tiada mesej diberikan")
        }

        window.open("https://wa.me/601169253770?text="
          + name + "%0D%0A"
          + email + "%0D%0A"
          + number + "%0D%0A"
          + budget + "%0D%0A"
          + service + "%0D%0A"
          + message + "%0D%0A")
      }

      else
      {
        this.clientError = true
      }

      
    },

    addPricing()
    {
        if(this.globalLanguage.selectedLanguage == "eng")
        {
          this.budgetItem = PRICINGENG
        }
        else if(this.globalLanguage.selectedLanguage == "bm")
        {
          this.budgetItem = PRICINGBM
        }
    },

    budgetCalculation(item)
    {
      var total = 0
      for(var i = 0 ; i<item.length ; i++)
      {
        if(item[i].selected)
        {
          total = total + item[i].price
        }
      }

      return total
    },

    routePage(link)
    {
      this.$router.push(link) 
    },

    openLink(link)
    {
      window.open(link)
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/Landing.vue